import ProjectCard from "./ProjectCard";

const Projects = ({ items }) => {
	return (
		<>
			<div className=" m-20 grid sm:grid-cols-2  lg:grid-cols-3 xl:grid-cols-4 gap-10">
				{items.map((project) => {
					const { id } = project;
					return <ProjectCard key={id} project={project} />;
				})}
			</div>
		</>
	);
};

export default Projects;
